/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      owner
      name
      description
      address
      website
      profileImage {
        name
        key
        url
        __typename
      }
      locationId
      location {
        id
        owner
        name
        zip
        address1
        address2
        address3
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationUserId
        __typename
      }
      materials {
        items {
          id
          owner
          title
          description
          woodType
          kind
          price
          characters
          size {
            x
            y
            z
            __typename
          }
          thicknesses
          finishes
          dryingMethods
          originalImage {
            name
            key
            url
            __typename
          }
          scannedImage {
            name
            key
            url
            __typename
          }
          dxfFile {
            name
            key
            url
            __typename
          }
          images {
            name
            key
            url
            __typename
          }
          isOnSale
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          comments {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          userMaterialsId
          locationMaterialsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        name
        description
        address
        website
        profileImage {
          name
          key
          url
          __typename
        }
        locationId
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      owner
      name
      zip
      address1
      address2
      address3
      user {
        id
        owner
        name
        description
        address
        website
        profileImage {
          name
          key
          url
          __typename
        }
        locationId
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      materials {
        items {
          id
          owner
          title
          description
          woodType
          kind
          price
          characters
          size {
            x
            y
            z
            __typename
          }
          thicknesses
          finishes
          dryingMethods
          originalImage {
            name
            key
            url
            __typename
          }
          scannedImage {
            name
            key
            url
            __typename
          }
          dxfFile {
            name
            key
            url
            __typename
          }
          images {
            name
            key
            url
            __typename
          }
          isOnSale
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          comments {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          userMaterialsId
          locationMaterialsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationUserId
      __typename
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        name
        zip
        address1
        address2
        address3
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationUserId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMaterial = /* GraphQL */ `
  query GetMaterial($id: ID!) {
    getMaterial(id: $id) {
      id
      owner
      title
      description
      woodType
      kind
      price
      characters
      size {
        x
        y
        z
        __typename
      }
      thicknesses
      finishes
      dryingMethods
      originalImage {
        name
        key
        url
        __typename
      }
      scannedImage {
        name
        key
        url
        __typename
      }
      dxfFile {
        name
        key
        url
        __typename
      }
      images {
        name
        key
        url
        __typename
      }
      isOnSale
      user {
        id
        owner
        name
        description
        address
        website
        profileImage {
          name
          key
          url
          __typename
        }
        locationId
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      location {
        id
        owner
        name
        zip
        address1
        address2
        address3
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationUserId
        __typename
      }
      comments {
        items {
          id
          owner
          content
          material {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          createdAt
          updatedAt
          materialCommentsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userMaterialsId
      locationMaterialsId
      __typename
    }
  }
`;
export const listMaterials = /* GraphQL */ `
  query ListMaterials(
    $filter: ModelMaterialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMaterials(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        title
        description
        woodType
        kind
        price
        characters
        size {
          x
          y
          z
          __typename
        }
        thicknesses
        finishes
        dryingMethods
        originalImage {
          name
          key
          url
          __typename
        }
        scannedImage {
          name
          key
          url
          __typename
        }
        dxfFile {
          name
          key
          url
          __typename
        }
        images {
          name
          key
          url
          __typename
        }
        isOnSale
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        comments {
          items {
            id
            owner
            content
            createdAt
            updatedAt
            materialCommentsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userMaterialsId
        locationMaterialsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getComment = /* GraphQL */ `
  query GetComment($id: ID!) {
    getComment(id: $id) {
      id
      owner
      content
      material {
        id
        owner
        title
        description
        woodType
        kind
        price
        characters
        size {
          x
          y
          z
          __typename
        }
        thicknesses
        finishes
        dryingMethods
        originalImage {
          name
          key
          url
          __typename
        }
        scannedImage {
          name
          key
          url
          __typename
        }
        dxfFile {
          name
          key
          url
          __typename
        }
        images {
          name
          key
          url
          __typename
        }
        isOnSale
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        comments {
          items {
            id
            owner
            content
            createdAt
            updatedAt
            materialCommentsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userMaterialsId
        locationMaterialsId
        __typename
      }
      createdAt
      updatedAt
      materialCommentsId
      __typename
    }
  }
`;
export const listComments = /* GraphQL */ `
  query ListComments(
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        content
        material {
          id
          owner
          title
          description
          woodType
          kind
          price
          characters
          size {
            x
            y
            z
            __typename
          }
          thicknesses
          finishes
          dryingMethods
          originalImage {
            name
            key
            url
            __typename
          }
          scannedImage {
            name
            key
            url
            __typename
          }
          dxfFile {
            name
            key
            url
            __typename
          }
          images {
            name
            key
            url
            __typename
          }
          isOnSale
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          comments {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          userMaterialsId
          locationMaterialsId
          __typename
        }
        createdAt
        updatedAt
        materialCommentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
